import React from 'react';
import { useTheme } from 'styled-components';
import { IconFilledInfo, Skeleton, Tooltip } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import { useViewport } from '@/hooks/useViewport';
import ActivitiesChart from '../../components/ActivitiesChart/ActivitiesChart';
import {
  GatorProtectDateRangeBadge,
  GatorProtectPanel,
  GatorProtectPanelTitle,
} from '../../GatorProtectHandler.styles';
import { ChartSectionHeader } from './ChartSection.styles';
import { ChartSectionLocale, ChartSectionTheme, ChartSectionProps } from './ChartSection.types';

const PAGE_SIZE_DESKTOP = 10;
const PAGE_SIZE_MOBILE = 6;


const ChartSection = ({
  sectionId,
  data,
  isLoading = false,
}: ChartSectionProps) => {
  const { gatorProtect: gatorProtectLocale } = useLocale() as ChartSectionLocale;
  const activitiesChart = gatorProtectLocale && gatorProtectLocale.activitiesChart;
  const title = (activitiesChart && activitiesChart.title) || '';
  const titleInfoTooltip = (activitiesChart && activitiesChart.titleInfoTooltip) || '';
  const filterLabel = (activitiesChart && activitiesChart.filter && activitiesChart.filter.last30Days) || '';

  const theme = useTheme() as ChartSectionTheme;
  const viewport = useViewport();
  const mdBreakpoint = parseInt(theme.v3.breakpoints.md, 10);
  const pageSize = viewport.width < mdBreakpoint ? PAGE_SIZE_MOBILE : PAGE_SIZE_DESKTOP;

  if (isLoading) {
    return (
      <GatorProtectPanel data-testid={sectionId}>
        <Skeleton height="400px" width="100%" />
      </GatorProtectPanel>
    );
  }

  return (
    <GatorProtectPanel data-testid={sectionId}>
      <ChartSectionHeader>
        <div>
          <GatorProtectPanelTitle>
            {title}
            <Tooltip content={titleInfoTooltip} preferredPosition="right">
              <IconFilledInfo color="primaryBlue" size="sm" />
            </Tooltip>
          </GatorProtectPanelTitle>
        </div>
        <GatorProtectDateRangeBadge>
          {filterLabel}
        </GatorProtectDateRangeBadge>
      </ChartSectionHeader>
      <ActivitiesChart data={data || []} pageSize={pageSize} />
    </GatorProtectPanel>
  );
};

export default ChartSection;
